export class WithdrawalStatus{
    
       /**Получить статус на р.я.*/ 
    public static getStringStatus(status: string){
        let statuses = {
          'pending': 'Ожидается',
          'error' : 'Ошибка',
          'success' : 'Успешно',
          'declined' : 'Ошибка',
        }
        return statuses[status.toLowerCase()] 
       }
}


// WEBPACK FOOTER //
// ./src/app/core/constants/withdrawal.status.ts